<template>
  <div class="bg-backend flex flex-col justify-between min-h-screen">
    <div>
      <top-layout-navigation />
      <router-view :key="$route.path" v-slot="{ Component }">
        <!--      <transition enter-active-class="transition ease-out duration-100" enter-from-class="transform opacity-0 scale-95" enter-to-class="transform opacity-100 scale-100" leave-active-class="transition ease-in duration-75" leave-from-class="transform opacity-100 scale-100" leave-to-class="transform opacity-0 scale-95">-->
        <component :is="Component" :key="'viewer-' + $route.path" />
        <!--      </transition>-->
      </router-view>
    </div>
    <tw-container class="pb-6 pt-8">
      <grouprev-public-footer />
    </tw-container>
  </div>
</template>

<script>
import Navigation from '@/components/TopNavigation.vue'
import OrganizationRegisterModal from '@/components/organizations/organization-register-modal.vue'
import TwContainer from '@/components/generic/tw-container.vue'
import GrouprevPublicFooter from '@/components/grouprev-public-footer.vue'
import TopLayoutNavigation from '@/components/backend/top-layout-navigation.vue'

export default {
  name: 'BackendPages',
  components: { TopLayoutNavigation, GrouprevPublicFooter, TwContainer, OrganizationRegisterModal, Navigation },
}
</script>
